/**
 * Shared CSS-variable primitives for the widget style twins that live beside
 * each widget's `.base.less` in this package.
 *
 * Nothing here reaches for `@sites/site-theme`: entity-core stays framework-free, so
 * a builder that needs theme resolution takes it as a parameter — see
 * {@link ThemeColorCssResolver} and, for the button family's richer contract,
 * `widget/form/styles/themed-button.css-vars.ts`.
 */

/** A CSS custom-property map. `null` removes the property. */
export type CssVarsMap = Record<string, string | null>;

/**
 * Resolves a stored theme colour — a preset name or a literal CSS colour — to a
 * CSS value, returning `''` when nothing is set. Mirrors `themeColorCss` from
 * `@sites/site-theme`, which every host passes in directly so the builders keep the
 * exact semantics they had before moving into this package.
 */
export type ThemeColorCssResolver = (property: string) => string;

/**
 * Maps the horizontal-alignment bucket every widget stores as `'L' | 'M' | 'R'`
 * (the host's `EHorizontalPosition`) to the matching flexbox `justify-content`
 * keyword. Keyed by plain strings: entity-core models these buckets as zod
 * literal unions, and a `Record<string, string>` accepts both the schema type and
 * the host enum members without a cast.
 */
export const JUSTIFY_BY_ALIGN: Record<string, string> = {
    L: 'flex-start',
    M: 'center',
    R: 'flex-end',
};
